import { Stack, StackItem } from "@fluentui/react";
import { Caption1 } from "@fluentui/react-components";

const overflowIcon = (label: string) => (icons: any) => (
  <Stack tokens={{ childrenGap: 5 }} horizontal>
    <StackItem> {icons} </StackItem>
    <StackItem> <Caption1> {label} </Caption1> </StackItem>
  </Stack>
);

export const createIcons = (text: string) => overflowIcon(`Create ${text}`);
export const exportIcons = overflowIcon("Export");
export const deleteIcons = overflowIcon("Delete");
export const refreshIcons = overflowIcon("Refresh");
export const manageViewIcons = overflowIcon("Manage View");
export const filterIcons = overflowIcon("Filter");
export const resetFilterIcons = overflowIcon("Reset Filters");
